/**
 * PLP Product Grid — renders cards in grid or list layout based on viewMode.
 */
(function () {
  const { html } = window.preact;

  function ProductGrid({ products, viewMode, onAddToCart }) {
    if (!products || products.length === 0) {
      return html`
        <div class="plp-grid__empty">
          <p>No products found. Try adjusting your filters.</p>
        </div>
      `;
    }

    if (viewMode === 'list') {
      return html`
        <div class="plp-grid plp-grid--list">
          ${products.map(
            (p) => html`
              <${window.PlpProductCardList}
                key=${p.objectID}
                product=${p}
                onAddToCart=${onAddToCart}
              />
            `
          )}
        </div>
      `;
    }

    return html`
      <div class="plp-grid plp-grid--grid">
        ${products.map(
          (p) => html`
            <${window.PlpProductCardGrid}
              key=${p.objectID}
              product=${p}
              onAddToCart=${onAddToCart}
            />
          `
        )}
      </div>
    `;
  }

  window.PlpProductGrid = ProductGrid;
})();
